import advancedSearchResultsComponent from './advanced-search-results.component';

const advancedSearchResultsModule = angular.module('advancedSearchResults', [
])
  .component('advancedSearchResults', advancedSearchResultsComponent)
  .name;

export default advancedSearchResultsModule;
